import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { theme } from "./theme";
import { ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";
import TanStackQueryProvider from "shared/libs/reactQuery/ReactQueryProvider";
// import { AuthProvider } from "shared/contexts/AuthContext";

import { LoadingProvider } from "shared/contexts/LoadingContext";
import { Provider } from "react-redux";
import store from "shared/stores/store";
import { initMsal } from "shared/libs/azure-msal";

// Default to using the first account if no account is active on page load
// if (isBlankOrNull(msalInstance.getActiveAccount()) && msalInstance.getAllAccounts().length > 0) {
//   // Account selection logic is app dependent. Adjust as needed for different use cases.
//   msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
// }
// // Listen for sign-in event and set active account
// msalInstance.addEventCallback(event => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//     const account = event.payload.account;
//     msalInstance.setActiveAccount(account);
//   }
// });
const msalInstance = await initMsal();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoadingProvider>
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={10}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        style={{ background: "#f9ffb1", color: "black" }}>
        <Provider store={store}>
          <TanStackQueryProvider>
            <App instance={msalInstance} />
          </TanStackQueryProvider>
        </Provider>
      </SnackbarProvider>
    </ThemeProvider>
  </LoadingProvider>
);
